var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6892 1.77889L13.3812 5.16289C13.6092 5.63089 14.2212 6.07489 14.7372 6.17089L17.7972 6.67489C19.7532 6.99889 20.2092 8.41489 18.8052 9.83089L16.4172 12.2189C16.0212 12.6149 15.7932 13.3949 15.9252 13.9589L16.6092 16.9109C17.1492 19.2389 15.9012 20.1509 13.8492 18.9269L10.9812 17.2229C10.4652 16.9109 9.60122 16.9109 9.08522 17.2229L6.21722 18.9269C4.16522 20.1389 2.91722 19.2389 3.45722 16.9109L4.14122 13.9589C4.24922 13.3829 4.02122 12.6029 3.62522 12.2069L1.23722 9.81889C-0.166781 8.41489 0.28922 6.99889 2.24522 6.66289L5.30522 6.15889C5.82122 6.07489 6.43322 5.61889 6.66122 5.15089L8.35322 1.76689C9.27722 -0.0571055 10.7652 -0.0571058 11.6892 1.77889Z",
    fill: "#F9BB4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarFilled);
export default __webpack_public_path__ + "static/media/ic_star_filled.57826f8c435e935333b8ce48d527d441.svg";
export { ForwardRef as ReactComponent };